(function() {
    // 注册组件
    SR.modules.extend('answer.renderCallback', renderCallback);

    function renderCallback(options) {
        var isImmersive = SR.state.isImmersive;
        var showAnimate = SR.state.showAnimate;
        var $wrapper = SR.dom.$wrapper;
        var $historyWrapper = SR.dom.$historyWrapper;
        var $scrollWrap = SR.dom.$scrollWrap;
        var $body = SR.dom.$body;
        var winH = SR.data.deviceInfo.height;
        var scrollAnimateDuration = SR.data.scrollAnimateDuration;
        var getAnswersCallbackTimer;
        var autoJumpWaitingTime = SR.data.autoJumpWaitingTime;
        var outAnimateTime = showAnimate ? 600 : 0;
        var removeTime = showAnimate ? 200 : 0;
        var loadingTag = SR.data.loadingTag;

        var data = options.data;
        var answerDomId = options.answerDomId;
        var prevAskDomId = options.askOptions.askId; // 重新提问时，原有的 askId
        var askDomId = options.askDomId; // 每次提问都会生成新的 askId
        var $answer = $('#' + answerDomId);
        var scrollTimer;

        if (options.showAnimate) {
            SR.util.enterAnimate($answer, options.enterAnimateStyle + ' fastest');
        }

        setTimeout(function() {
            // 广播 renderAnswerCompleted 事件，用于特定场景处理
            var triggerEvent = 'renderAnswerCompleted' 
                                + (options.askOptions.isLoadHistory ? ':history' : '')
                                + (options.askOptions.isTheater ? ':theater' : '');
            SR.App.trigger(triggerEvent, [options]);
            SR.state.isDebug && console.info('fire:' + triggerEvent);
        }, (options.showAnimate ? outAnimateTime + removeTime : 0));

        function setScrollPos() {
            scrollTimer = setTimeout(function() {
                if ($scrollWrap.is(':animated')) {
                    $scrollWrap.stop();
                }
                // 滑动页面到当前回答位置
                var $currentDom = $answer;
                if ($currentDom.length) {
                    var currentDomH = $currentDom.height();
                    var scrollTop = $historyWrapper.height() +
                                    $wrapper.height() -
                                    Math.max(currentDomH + 30, winH) +
                                    20 +
                                    (SR.state.hasHistory ? 0 : 20);
                    if (SR.state.isH5Mode) {
                        var askBarH = SR.dom.$askBar.height();
                        if (currentDomH < winH - askBarH) {
                            scrollTop += askBarH + 20;
                        }
                    }
                    // 滑条定位
                    // console.log(scrollTop);
                    if (scrollTop > 0) {
                        $scrollWrap.animate(
                            {scrollTop: scrollTop},
                            (options.showAnimate ? 300 : scrollAnimateDuration)
                        );
                    }
                }
            }, (options.showAnimate ? 0 : 100));
        }

        if (options.askOptions.scrollToAnswer) {
            setScrollPos();
        }

        if (data.type === 'stock') {
            switch (data.scene) {
                case 30:
                    // 智能组合
                    var status = data.data && data.data.userStatus;
                    if (getAnswersCallbackTimer) {
                        clearTimeout(getAnswersCallbackTimer);
                    }
                    if (status === 0) {
                        // 未登录
                        getAnswersCallbackTimer = setTimeout(function() {
                            if (!options.askOptions.isLoadHistory) {
                                $answer.find('.status-text').text('打开');
                                $answer.find('.J_invokeAppEvent').attr('data-actionType', 'auto').trigger('click');
                            }
                        }, autoJumpWaitingTime);
                        if (options.askOptions.isLoadHistory) {
                            $answer.find('.status-text').text('您还未登录，请打开');
                        }
                    } else if (status === 1) {
                        // 用户未参与评测，将问题记录至 SR.data.askAgain
                        if (!options.askOptions.isLoadHistory) {
                            SR.data.askAgain.push({
                                question: options.question,
                                askType: 'reload',
                                askId: prevAskDomId || askDomId // 重问时优先使用重问 askId
                            });
                            // 当前 session 首次提问时才自动跳转
                            SR.haveBeenToRiskTest = true;
                            getAnswersCallbackTimer = setTimeout(function() {
                                if (!options.askOptions.isLoadHistory) {
                                    $answer.find('.status-text').text('打开');
                                    $answer.find('.J_invokeAppEvent').attr('data-actionType', 'auto').trigger('click');
                                }
                            }, autoJumpWaitingTime);
                        } else {
                            $answer.find('.J_invokeAppEvent').attr('data-actionType', 'auto');
                            $answer.find('.status-text').text('您未完成风险测评，请打开');
                        }
                    } else if (status === 1.5) {
                        $answer.find('.J_invokeAppEvent').attr('data-actionType', 'auto');
                    } else if (status === 3) {
                        getAnswersCallbackTimer = setTimeout(function() {
                            if (!options.askOptions.isLoadHistory) {
                                $answer.find('.status-text').text('打开');
                                $answer.find('.J_invokeAppEvent').attr('data-actionType', 'auto').trigger('click');
                            }
                        }, autoJumpWaitingTime);
                    }
                    break;
                case 33:
                    // 股价预测饼图
                    if (data.data && data.data.list && data.data.list.length) {
                        var ringWidth = 12;
                        var bgWidth = 12;
                        var linecap = 'butt';
                        if (isImmersive) {
                            ringWidth = 4;
                            bgWidth = 2;
                            linecap = 'round';
                        }
                        var pie = new SR.modules.svgPie({
                            element: '#rise-pie-' + answerDomId,
                            ringWidth: ringWidth,
                            bgWidth: bgWidth,
                            linecap: linecap,
                            animite: true,
                            animiteDelay: 400,
                            isShowNumber: true,
                            // direction: 'counterclockwise'
                            gradient: {
                                id: 'linear',
                                type: 'linear',
                                color: [
                                  {offset:'0%', 'stop-color': SR.theme.linearGradient.startColor},
                                  {offset:'100%','stop-color': SR.theme.linearGradient.endColor}
                                ]
                            }
                        });
                        pie.draw();
                    }
                    break;
                case 36:
                case 80:
                    // 大盘风向
                    var pie1 = new SR.modules.svgPie({
                        element: '#advise-pie-' + answerDomId,
                        color: '#7ab3fb',
                        rotate: -180,
                        ringWidth: 15,
                        showText: false,
                        animite: true,
                        animiteDelay: 500,
                        mask: {
                            dasharray: '2.9,2.9',
                            color: SR.theme.linearGradient.maskColor
                        },
                        gradient: {
                            id: 'linear1',
                            type: 'linear',
                            color: [
                              {offset:'45%', 'stop-color': SR.theme.linearGradient.startColor},
                              {offset:'100%', 'stop-color': SR.theme.linearGradient.endColor}
                            ]
                        }
                    });
                    var pie2 = new SR.modules.svgPie({
                        element: '#up-prob-pie-' + answerDomId,
                        rotate: -180,
                        ringWidth: 15,
                        showText: false,
                        animite: true,
                        animiteDelay: 500,
                        mask: {
                            dasharray: '2.9,2.9',
                            color: SR.theme.linearGradient.maskColor
                        },
                        gradient: {
                            id: 'linear2',
                            type: 'linear',
                            color: [
                              {offset:'45%', 'stop-color': SR.theme.linearGradient.startColor},
                              {offset:'100%', 'stop-color': SR.theme.linearGradient.endColor}
                            ]
                        }
                    });
                    pie1.draw();
                    pie2.draw();
                    break;
                case 54:
                    // 语音下单
                    var $second = $answer.find('.second');
                    var $cancel = $answer.find('.J_cancel');
                    var $trigger = $answer.find('.J_invokeAppEvent');
                    var second = parseInt($second.text());
                    if (!options.askOptions.isLoadHistory && second >= 0) {
                        var countDownTimer = setInterval(function () {
                            if (second > 1) {
                                second -= 1;
                                $second.text(second);
                            } else {
                                // 跳转至下单界面
                                cancelCountDownTimer();
                                $trigger.trigger('click');
                            }
                        }, 1000);
                    } else {
                        cancelCountDownTimer();
                    }
                    $cancel.on('click', function() {
                        cancelCountDownTimer();
                    });
                    function cancelCountDownTimer() {
                        $answer.find('.tips').text('前往下单界面');
                        $cancel.hide();
                        clearInterval(countDownTimer);
                    }
                    break;
                case 79:
                    var $trigger = $answer.find('.title');
                    $trigger.on('click', function() {
                        var $me = $(this);
                        if ($me.hasClass('show-all')) {
                            $me.removeClass('show-all');
                        } else {
                            $me.addClass('show-all');
                        }
                    });
                    break;
                case 'guide':
                    var iQuestions = SR.data.guideQuestions;
                    if (SR.state.categoryGuide) {
                        $(SR.data.guideQuestions.qs).each(function() {
                            var $slideItem = $('<div class="swiper-slide"></div>');
                            $(this.questions).each(function(index){
                                if (index > 4) {
                                    return;
                                }
                                var $a = $('<a class="J_ask list-item" data-option="{\'inputType\': 2}">'+ this +'</a>');
                                $slideItem.append($a);
                            });
                            $answer.find('.swiper-wrapper').append($slideItem);
                        });
                        var buildQuestions = new SR.component.swiperContent({
                            element: '#' + answerDomId + ' .swiper-container'
                        });
                    } else {
                        iQuestions = SR.data.guideQuestions.qs;
                        if (typeof iQuestions[0] === 'object') {
                            iQuestions = [];
                            $(iQuestions).each(function(index) {
                                iQuestions = iQuestions.concat(this.questions);
                            });
                        }
                        if (SR.data.guideQuestions.tqs) {
                            iQuestions = SR.data.guideQuestions.tqs.concat(iQuestions);
                        }
                        var buildQuestions = new SR.component.questionSwither(iQuestions, {
                            element: '#' + answerDomId + ' .nr-guide-container',
                            button: '.J_changeQuestion',
                            buttonText: '换一换'
                        });
                    }
                    break;
            }
        } else if (data.type === 'lbs') {
        } else if (data.type === 'suggestion') {
            SR.component.foldContent(answerDomId);
        } else if (data.type === 'external') {
            // 加载第三方数据
            clearTimeout(scrollTimer);
            $body.addClass(loadingTag);
            var externalContainer = new SR.component.externalContainer;
            externalContainer.create({
                contentType: data.data.contentType,
                api: data.data.url,
                img: data.data.img,
                answerDomId: answerDomId,
                success: function() {
                    if (options.askOptions.scrollToAnswer) {
                        setScrollPos();
                    }
                    $body.removeClass(loadingTag);
                },
                error: function() {
                    // 请求三方数据失败时，通常场景返回是成功的，所以 repeat 时 askDomId 会发生变化，
                    // 所以这里需要手动更新 askDomId
                    $answer.prev('.msg.me').attr('id', options.askDomId);
                    setTimeout(function() {
                        SR.modules.answer.repeat(options.askDomId);
                    }, (options.showAnimate ? outAnimateTime + removeTime : 0));
                    $body.removeClass(loadingTag);
                }
            });
        } else if (data.type === 'qa' || data.type === 'kefu') {
            SR.component.foldContent(answerDomId);
            switch (data.scene) {
                case 1:
                    $answer.find('.content a').each(function() {
                        var $a = $(this);
                        var url = $a.attr('href');
                        if (url === 'http://tel') {
                            $a.attr('href', 'tel:' + $a.text());
                        } else {
                            $a.addClass('J_invokeAppEvent').attr('data-params', '{"action": "viewInWebview", "url": "' + url + '"}');
                        }
                    });
                    break;
                case 5:
                    if (data.type === 'kefu') {
                        var $triggerBtn = $('.J_CSChangeMode');
                        if ($triggerBtn.length > 0) {
                            if (!SR.state.CSConnecting) {
                                $triggerBtn.trigger('click');
                                $answer.remove();
                            }
                        } else {
                            $answer.find('.content').html('转接失败，请重试。');
                        }
                        break;
                    }
            }
        } else if (data.type === 'operation') {
            // 运营场景
            if (getAnswersCallbackTimer) {
                clearTimeout(getAnswersCallbackTimer);
            }
            if (options.askOptions.isLoadHistory) {
                $answer.find('.status-text').text('点击打开');
            } else if (!options.askOptions.ignoreAutoJump) {
                getAnswersCallbackTimer = setTimeout(function() {
                    $answer.find('.status-text').text('打开');
                    $answer.find('.J_invokeAppEvent').trigger('click');
                }, autoJumpWaitingTime);
            }
        } else if (data.type === 'thirdparty') {
            switch (data.scene) {
                case 6:
                    var locationData = {};
                    locationData.callback = function(data) {

                    }
                    upNativeComm.exec('Location.getOutlets', locationData);
                    function renderList(data) {
                        var listHtml = '';

                        $answer.find('.content');
                    }
                    break;
            }
        }
    }
})();
